import { render, staticRenderFns } from "./RestoreAccountWindow.vue?vue&type=template&id=07853f57&"
import script from "./RestoreAccountWindow.vue?vue&type=script&lang=js&"
export * from "./RestoreAccountWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports